import { hasPersist } from './hasPersist';
import { Store } from './types/Store';

/**
 * Adds a `.reset()` method to the store, restoring initial state and clearing persisted state if present.
 */
export const withReset = <T>(
  store: Store<T>,
  initialState: T,
  ignoreReset: boolean,
) => {
  store.reset = () => {
    if (ignoreReset) {
      return;
    }

    // Reassign values to the store's initial state instead of replacing it entirely,
    // since the captured initial state excludes computed properties and methods.
    store.setState(initialState);

    if (hasPersist(store)) {
      store.persist.clearStorage();
    }
  };
};
